import script from "./AnchorAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./AnchorAdmin.vue?vue&type=script&setup=true&lang=js"

import "./AnchorAdmin.vue?vue&type=style&index=0&id=5cea75e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cea75e2"]])

export default __exports__